import OverallRiskBlock from './OverallRiskBlock';

export default OverallRiskBlock;
